import {
  IonContent,
  IonPage
} from '@ionic/react';
import React from 'react';
import Footer from '../components/Footer';
import BottomCTA from '../components/landing/BottomCTA';
import CTA from '../components/landing/CTA';
import FAQ from '../components/landing/FAQ';
import Features from '../components/landing/Features';
import LandingNavbar from '../components/LandingNavBar';
const Landing: React.FC = () => {
  return (
    <IonPage className="ion-page-flex">
      <IonContent className="ion-content-flex absolute h-dvh">
        <LandingNavbar />
        <CTA />
        <Features />
        <FAQ />
        <BottomCTA />
        <Footer />
      </IonContent>
    </IonPage>
  );
};

export default Landing;
